"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class DynamicHPSection {
    constructor() {
        this.getProductVecSearchData = (handleChosen) => __awaiter(this, void 0, void 0, function* () {
            if (this.searchCache.productVec) {
                return this.searchCache.productVec;
            }
            else {
                const data = yield moobiQueries.productVectorSearch(handleChosen);
                if (!data)
                    throw new Error('No valid reply from vector search API');
                const activeData = data.data.filter((el) => {
                    return el.document.published;
                });
                this.searchCache.productVec = { status: 200, data: activeData };
                return { status: 200, data: activeData };
            }
        });
        this.getSmtCollectionVecSearchData = (handleChosen) => __awaiter(this, void 0, void 0, function* () {
            if (this.searchCache.smtCollectionVec) {
                return this.searchCache.smtCollectionVec;
            }
            else {
                const data = yield moobiQueries.smtCollectionVectorSearch(handleChosen);
                if (!data)
                    throw new Error('No valid reply from vector search API');
                const publishedData = data.data.filter((el) => {
                    if (el.document.published_at) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                this.searchCache.smtCollectionVec = { status: 200, data: publishedData };
                return { status: 200, data: publishedData };
            }
        });
        this.initState = {
            sectionID: {
                featuredProduct: 'dynamicHP_featuredProduct_container',
                featuredColumn: 'dynamicHP_featureColumn_container',
                featuredCollection: 'dynamicHP_collection_container',
                featuredVideo: 'dynamicHP_featuredVideo_container',
                featuredArticle: 'dynamicHP_article_container',
                featuredSuggestions: 'dynamicHP_productSuggestions_container',
                purchasedProducts: "dynamicHP_purchasedProducts_container"
            },
        };
        this.searchCache = { productVec: undefined, smtCollectionVec: undefined };
        this.initState.defaultProductHandle = this.getDefaultFeatureProductHandle(),
            this.initState.defaultVideoHandle = this.getVideoHandle(),
            this.initState.purchasedProductsHandles = this.getPurchasedProducdtsHandles(),
            this.initState.gSearchTerm = this.getGSearchTerm(),
            this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getSmartCollectionFromVisitRecord();
            this.getProductVisitRecord();
            const handles = this.getRandomizedHandles();
            if (!handles) {
                this.unhideAll();
                return;
            }
            this.updateFeaturedProduct(handles);
            this.updateProductsSuggestion(handles);
            this.updateFeaturedArticle(handles);
            this.updateSmtCollections(handles);
        });
    }
    // checks and random logics
    getzeroOrOne() {
        if (MoobiUtilities.setProbability(50))
            return 0;
        else
            return 1;
    }
    // get searchTerm from URL
    getGSearchTerm() {
        const decodedURL = decodeURI(window.location.href);
        const params = new URL(decodedURL).searchParams;
        const utmTerm = params.get('utm_term');
        if (!utmTerm)
            return undefined;
        if (utmTerm.includes('moobi') || utmTerm.includes('MOOBI'))
            return undefined;
        return utmTerm;
    }
    getWeightedVProductResults(vProducts, vWeight) {
        const dataSortedByOrder = vProducts.data.sort((a, b) => {
            return a.document.order - b.document.order;
        }).map((el_01, ind_01) => {
            const dataWithOrderInd = Object.assign(Object.assign({}, el_01), { orderInd: ind_01 });
            return dataWithOrderInd;
        });
        const weightedVProductData = dataSortedByOrder.sort((a, b) => {
            return a.vector_distance - b.vector_distance;
        }).map((el_02, ind) => {
            const weightedIndex = el_02.orderInd * (1 - vWeight) + ind * vWeight;
            const dataWithWeightedInd = Object.assign(Object.assign({}, el_02), { weightedIndex });
            return dataWithWeightedInd;
        });
        const sortedWeightedVProductData = weightedVProductData.sort((a, b) => {
            return a.weightedIndex - b.weightedIndex;
        });
        return {
            status: 200,
            data: sortedWeightedVProductData
        };
    }
    // get DOM and storage data
    getSmartCollectionFromVisitRecord() {
        return __awaiter(this, void 0, void 0, function* () {
            const smartCollection = yield getProductListFromLog.initProductListfromLog();
            this.initState.smartCollectionFromVisitRecord = smartCollection;
        });
    }
    getProductVisitRecord() {
        const topVisitedProduct = getProductListFromLog.getTopProductInfo();
        if (!topVisitedProduct)
            return;
        this.initState.productVisitRecord = topVisitedProduct;
    }
    getPurchasedProducdtsHandles() {
        const purchasedContainer = document.getElementById(this.initState.sectionID.purchasedProducts);
        if (!purchasedContainer)
            return [];
        const productItems = purchasedContainer.querySelectorAll('.productItem');
        const handles = Array.from(productItems).map((el) => {
            const elm = el;
            if (elm.dataset.searchstring) {
                return elm.dataset.searchstring;
            }
            else
                return undefined;
        });
        const filteredHandles = handles.filter((el_01) => {
            if (!el_01)
                return false;
            else
                return true;
        });
        return filteredHandles;
    }
    getDefaultFeatureProductHandle() {
        const featuredProductElm = document.getElementById(this.initState.sectionID.featuredProduct);
        const singleItem = featuredProductElm.querySelector('.singleItem');
        const handle = singleItem.dataset.searchstring;
        return handle;
    }
    getVideoHandle() {
        const videoContainer = document.getElementById(this.initState.sectionID.featuredVideo);
        if (!videoContainer)
            return undefined;
        const handle = videoContainer.dataset.searchstring;
        if (!handle)
            return undefined;
        return handle;
    }
    getSearchStringFromVisitRecord() {
        var _a, _b, _c, _d;
        const title = ((_a = this.initState.productVisitRecord) === null || _a === void 0 ? void 0 : _a.handle) ? (_b = this.initState.productVisitRecord) === null || _b === void 0 ? void 0 : _b.handle : '';
        const tags = ((_c = this.initState.productVisitRecord) === null || _c === void 0 ? void 0 : _c.tags) ? (_d = this.initState.productVisitRecord) === null || _d === void 0 ? void 0 : _d.tags : '';
        return title + tags;
    }
    getRandomizedHandles() {
        const topVisitedProductHandle = this.getSearchStringFromVisitRecord();
        const featuredVideoHandle = this.initState.defaultVideoHandle;
        const defaultProductHandle = this.initState.defaultProductHandle;
        const purchasedProductHandles = this.initState.purchasedProductsHandles;
        const searchTerm = this.initState.gSearchTerm;
        const handles = [{
                type: '為你推薦',
                handle: topVisitedProductHandle
            }, {
                type: '今期熱門',
                handle: featuredVideoHandle
            }, {
                type: '店長推介',
                handle: defaultProductHandle
            }, {
                type: '猜你喜歡',
                handle: purchasedProductHandles && purchasedProductHandles.length > 0 ? purchasedProductHandles[MoobiUtilities.randomNumberFromRange(0, (purchasedProductHandles.length - 1))] : undefined
            }].filter((el) => {
            if (!el.handle)
                return false;
            else
                return true;
        });
        if (handles.length < 1)
            return;
        if (searchTerm) {
            return {
                typeChosen: '熱搜推介',
                handleChosen: searchTerm
            };
        }
        const randomIndex = MoobiUtilities.randomNumberFromRange(0, handles.length - 1);
        const handleChosen = handles[randomIndex].handle;
        const typeChosen = handles[randomIndex].type;
        return { typeChosen, handleChosen };
    }
    getProductDataFromSmartCollection(data) {
        const productData = data.products.map((el, ind, arr) => {
            const dataObject = {
                src: MoobiUtilities.resizeImageSrc(el.image.src, 500),
                title: el.title,
                url: `/products/${el.handle}`,
                collection: data.handle,
                vendor: el.vendor
            };
            return dataObject;
        });
        return productData;
    }
    getProductDataFromVectorSearch(res) {
        const productData = res.data.map((el) => {
            const dataObject = {
                src: MoobiUtilities.resizeImageSrc(el.document.imgSrc, 500),
                title: el.document.title,
                url: `/products/${el.document.handle}`,
                collection: el.document.collectionTags[0],
                vendor: el.document.vendor,
                price: el.document.price,
                tags: el.document.tags
            };
            return dataObject;
        });
        return productData;
    }
    getBlogHandle(id) {
        const map = {
            81470783671: "wisdom-car-beauty",
            81471045815: "wisdom-startup",
            81470161079: "wisdom-repairs",
            83330367738: "car-repairs-tutorial",
        };
        const handle = map[id];
        return handle;
    }
    // render DOM
    insertCollectionButton(target, collection) {
        const collectionButtonCurrent = target.querySelector('.collection_button');
        if (collectionButtonCurrent) {
            collectionButtonCurrent.remove();
        }
        const collectionButton = document.createElement('a');
        collectionButton.href = `/collections/${collection}`;
        collectionButton.innerText = '同類商品';
        collectionButton.classList.add('collection_button');
        const contentWrapper = target.querySelector('.contentWrapper');
        contentWrapper.insertAdjacentElement('beforeend', collectionButton);
    }
    renderFeaturedProduct(type, productData) {
        const featuredProductElm = document.getElementById(this.initState.sectionID.featuredProduct);
        if (!featuredProductElm)
            return;
        const header = featuredProductElm.querySelector('h2');
        const image = featuredProductElm.querySelector('img');
        const title = featuredProductElm.querySelector('h4');
        const link = featuredProductElm.querySelector('a');
        const collectionButton = document.createElement('a');
        collectionButton.href = `/collections/${productData.collection}`;
        collectionButton.innerText = '同類商品';
        collectionButton.classList.add('collection_button');
        header.innerText = type;
        link.href = productData.url;
        image.srcset = "";
        image.src = productData.src;
        title.innerText = productData.title;
        this.unhideFeaturedProduct();
        this.insertCollectionButton(featuredProductElm, productData.collection);
    }
    renderProductSuggestion(type, option) {
        const productsSuggestionContainer = document.getElementById(this.initState.sectionID.featuredSuggestions);
        if (!productsSuggestionContainer)
            return;
        const items = productsSuggestionContainer.querySelectorAll('.grid_item');
        const basedOn = productsSuggestionContainer.querySelector('h2');
        basedOn.innerText = `${type}︰商品類目`;
        items.forEach((el, ind) => {
            const productData = option[ind];
            if (productData) {
                const image = el.querySelector('img');
                image.src = productData.src;
                const title = el.querySelector('h3');
                title.innerText = productData.title;
                const collection = el.querySelector('p');
                collection.innerText = productData.vendor;
                const link = el.querySelector('a');
                link.href = productData.url;
                const price = el.querySelector('.grid_item__content__price');
                price.innerText = `$${productData.price}`;
            }
        });
    }
    renderArticle(type, option) {
        const articleContainer = document.getElementById(this.initState.sectionID.featuredArticle);
        if (!articleContainer) {
            return;
        }
        const heading = articleContainer.querySelector('h2');
        heading.innerText = `${type}：必讀教學`;
        const link = articleContainer.querySelector('a');
        link.href = option.url;
        const image = articleContainer.querySelector('img');
        image.src = MoobiUtilities.resizeImageSrc(option.src, 500);
        image.srcset = "";
        const title = articleContainer.querySelector('h3');
        title.innerText = option.title;
        const exerpt = articleContainer.querySelector('p');
        const exerptSize = Number(exerpt.dataset.exerptsize);
        exerpt.innerText = `${MoobiUtilities.removeHtmlTags(option.exerpt).slice(0, exerptSize)}...`;
        this.unhideArticle();
    }
    renderSmtCollection(type, option) {
        const collectionContainer = document.getElementById(this.initState.sectionID.featuredCollection);
        if (!collectionContainer) {
            return;
        }
        const productCards = collectionContainer.querySelectorAll('.productItem');
        productCards.forEach((el, ind) => {
            const productData = option.products[ind];
            if (productData) {
                const link = el.querySelector('a');
                link.href = productData.url;
                const image = el.querySelector('img');
                image.src = MoobiUtilities.resizeImageSrc(productData.src, 500);
                image.srcset = "";
            }
        });
        const link = collectionContainer.querySelector('.collection_button');
        link.href = `/collections/${option.collection.handle}`;
        link.innerText = option.collection.title;
        this.unhideSmtCollections();
    }
    unhideElms(elms) {
        elms.forEach((el) => {
            el.classList.remove('hideImage');
            el.classList.remove('hideText');
            el.classList.remove('textSkeleton');
        });
    }
    unhideProductSuggestion() {
        const productsSuggestionContainer = document.getElementById(this.initState.sectionID.featuredSuggestions);
        if (!productsSuggestionContainer)
            return;
        const items = productsSuggestionContainer.querySelectorAll('.grid_item');
        const basedOn = productsSuggestionContainer.querySelector('h2');
        this.unhideElms([basedOn]);
        setTimeout(() => {
            items.forEach((el, ind) => {
                const image = el.querySelector('img');
                const title = el.querySelector('h3');
                const p = el.querySelector('p');
                const span = el.querySelector('span');
                this.unhideElms([image, title, p, span]);
            });
        }, 500);
    }
    unhidePurchasedItems() {
        const purchasedItemsContainer = document.getElementById(this.initState.sectionID.purchasedProducts);
        if (!purchasedItemsContainer)
            return;
        const items = purchasedItemsContainer.querySelectorAll('.grid_item');
        setTimeout(() => {
            items.forEach((el, ind) => {
                const image = el.querySelector('img');
                const title = el.querySelector('h3');
                const p = el.querySelector('p');
                const span = el.querySelector('span');
                this.unhideElms([image, title, p, span]);
            });
        }, 500);
    }
    unhideSmtCollections() {
        const collectionContainer = document.getElementById(this.initState.sectionID.featuredCollection);
        if (!collectionContainer) {
            return;
        }
        const items = collectionContainer.querySelectorAll('.productItem');
        setTimeout(() => {
            items.forEach((el, ind) => {
                const image = el.querySelector('img');
                this.unhideElms([image]);
            });
            const button = collectionContainer.querySelector('.collection_button');
            button.style.display = 'block';
        }, 500);
    }
    unhideArticle() {
        const articleContainer = document.getElementById(this.initState.sectionID.featuredArticle);
        if (!articleContainer) {
            return;
        }
        const heading = articleContainer.querySelector('h2');
        const link = articleContainer.querySelector('a');
        const image = articleContainer.querySelector('img');
        const title = articleContainer.querySelector('h3');
        const excerpt = articleContainer.querySelector('p');
        setTimeout(() => {
            this.unhideElms([heading, link, image, title, excerpt]);
        }, 500);
    }
    // unhideFeaturedCollection() {
    //     const articleContainer = document.getElementById(this.initState.sectionID.)
    //     if (!articleContainer) {
    //         return
    //     }
    //     const heading = articleContainer.querySelector('h2')!
    //     const link = articleContainer.querySelector('a')!
    //     const image = articleContainer.querySelector('img')!
    //     const title = articleContainer.querySelector('h3')!
    //     setTimeout(() => {
    //         this.unhideElms([heading, link, image, title])
    //     }, 500)
    // }
    unhideFeaturedProduct() {
        const featuredProductElm = document.getElementById(this.initState.sectionID.featuredProduct);
        if (!featuredProductElm)
            return;
        const header = featuredProductElm.querySelector('h2');
        const image = featuredProductElm.querySelector('img');
        const title = featuredProductElm.querySelector('h4');
        const link = featuredProductElm.querySelector('a');
        const button = featuredProductElm.querySelector('.collection_button');
        setTimeout(() => {
            this.unhideElms([image, title, header]);
            button.style.display = 'block';
        }, 500);
    }
    unhideAll() {
        setTimeout(() => {
            this.unhideArticle();
            // this.unhideFeaturedCollection()
            this.unhideProductSuggestion();
            this.unhideFeaturedProduct();
        }, 500);
    }
    // Handlers
    updateProductsSuggestion(handles) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.getProductVecSearchData(handles.handleChosen);
                const weightedProductData = this.getWeightedVProductResults(data, 0.6);
                const productData = this.getProductDataFromVectorSearch(weightedProductData);
                this.renderProductSuggestion(handles.typeChosen, productData);
                this.unhideProductSuggestion();
            }
            catch (error) {
                this.unhideProductSuggestion();
                console.log(error);
            }
        });
    }
    updateFeaturedArticle(handles) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (MoobiUtilities.setProbability(33)) {
                    // There is 33% chance to show the featured article
                    this.unhideArticle();
                    return;
                }
                const res = yield moobiQueries.articleVectorSearch(handles.handleChosen);
                if (!res)
                    throw new Error('No valid reply from vector search API');
                const publishedArticle = res.data.filter((el) => {
                    if (el.document.published_at) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                const randomIndex = MoobiUtilities.randomNumberFromRange(0, 1);
                const doc = publishedArticle[randomIndex].document;
                const blogHandle = this.getBlogHandle(doc.blog_id);
                const articleData = {
                    src: doc['image.src'],
                    title: doc.title,
                    url: `/blogs/${blogHandle}/${doc.handle}`,
                    exerpt: doc.summary_html
                };
                this.renderArticle(handles.typeChosen, articleData);
            }
            catch (error) {
                this.unhideArticle();
                console.log(error);
            }
        });
    }
    updateFeaturedProduct(handles) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (handles.typeChosen === '店長推介') {
                    this.unhideFeaturedProduct();
                    return;
                }
                if (handles.typeChosen === '猜你喜歡' || '熱搜推介') {
                    const data = yield this.getProductVecSearchData(handles.handleChosen);
                    // const smtCollectionData = await this.getSmtCollectionVecSearchData(handles.handleChosen)
                    const weightedData = this.getWeightedVProductResults(data, 0.6);
                    const productData = this.getProductDataFromVectorSearch(weightedData);
                    // .map((el) => {
                    //     return { ...el, collection: smtCollectionData.data[0].document.handle }
                    // })
                    const randomIndex = MoobiUtilities.randomNumberFromRange(0, 1);
                    const chosenProductData = productData[randomIndex] ? productData[randomIndex] : productData[0];
                    const collection = yield moobiQueries.getPdtLists(chosenProductData.tags);
                    this.renderFeaturedProduct(handles.typeChosen, Object.assign(Object.assign({}, chosenProductData), { collection: collection.handle }));
                }
                else {
                    if (!this.initState.smartCollectionFromVisitRecord) {
                        this.unhideFeaturedProduct();
                        return;
                    }
                    const smartCollection = this.initState.smartCollectionFromVisitRecord;
                    const productData = this.getProductDataFromSmartCollection(smartCollection);
                    const randomIndex = MoobiUtilities.randomNumberFromRange(0, 1);
                    const chosenProductData = productData[randomIndex] ? productData[randomIndex] : productData[0];
                    this.renderFeaturedProduct('為你推薦', chosenProductData);
                    return;
                }
            }
            catch (error) {
                console.log(error);
                this.unhideFeaturedProduct();
            }
        });
    }
    updateSmtCollections(handles) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.getSmtCollectionVecSearchData(handles.handleChosen);
                const productList = yield moobiQueries.getProductListbyCollectionId(res.data[0].document.id);
                if (!productList)
                    throw new Error('No valid reply from product list search API');
                const formatedProducts = productList.data.products.map((el) => {
                    return {
                        vendor: el.vendor,
                        title: el.title,
                        src: el.image.src,
                        url: `/products/${el.handle}`
                    };
                });
                this.renderSmtCollection(handles.typeChosen, {
                    collection: {
                        title: res.data[0].document.title,
                        handle: res.data[0].document.handle
                    },
                    products: formatedProducts
                });
            }
            catch (error) {
                console.log(error);
                this.unhideSmtCollections();
            }
        });
    }
    // Evoke
    evoke(logic) {
    }
}
const dynamicHPSection = new DynamicHPSection();
